export class SendDevis {
  surname: string;
  name: string;
  adresse_mail: string;
  fileRef: string;
  file_name: string;
  file_base64: any;
}
